import moment from '@/moment-gp'
import goalMemberModelDefinition from '../goalMember'
import deadlineItemModelDefinition from '../goalDeadline'

/* =============================================================================
DB:       Realtime DB
PATH:     goal.{goalId}.meta
PURPOSE:  Stores goals
============================================================================= */

// const empty_task = taskDefinition.create
// const empty_lane = commitmentDefinition.create;
const empty_goal_member = goalMemberModelDefinition.schema.create;
const empty_deadline_item = deadlineItemModelDefinition.schema.create;

function create_user_as_member( userPublic ) {
  let profile_pic = userPublic.profilePic; // TODO: Only works for uploaded picture
  let name = userPublic.firstName + ' ' + userPublic.lastName;
  return empty_goal_member({
    displayName: name,
    userPicture: profile_pic,
    isCreator: true
  });
}

export default {
  create( { name, creatorUserId, userPublic }, data, BACKEND ) {

    // let task1Id = util.get_new_uuid();
    // let task2Id = util.get_new_uuid();
    // let task3Id = util.get_new_uuid();
    // let lane1Id = util.get_new_uuid();
    // let lane2Id = util.get_new_uuid();

    /* Create Deadline in one week */
    let deadline = moment.currentDate().add(7, 'days').toBackend(BACKEND);

    // ACHTUNG [] wird von RTDB nicht erkannt, von Firestore schon
    let deadlineList = data.addTestDeadline
                     ? [ empty_deadline_item( "Test-Deadline", deadline ) ]
                     : [] /* Default: Empty deadline list */

    let userAsGoalMember = data.isTemplate ? null : create_user_as_member( userPublic );

    return {
      name:           name,
      createdAt:      moment.currentTimeServer(BACKEND),
      createdBy:      creatorUserId,
      description:    data.description || "",
      rules:          data.rules || "",
      deleted:        false, // TODO: Not required for isTemplate
      members:        data.isTemplate
                      ? {}
                      : { [creatorUserId]: userAsGoalMember },
      visibility:     "public",// private, friends only, accountability buddies only, on invitation only, with link only, public
      isTeamgoal:     data.isTeamgoal === undefined ? true : data.isTeamgoal, // same as visibility?
      deadlineList:   deadlineList,
      picture:        data.picture || '', // TODO Default image "http://3.bp.blogspot.com/-EkOWmmjUDuk/VmKDeQmZeTI/AAAAAAAAANs/hRayvFQKhdE/s1600/9192_2_hambatan_utama_tingkatkan_massa_otot_di_luar_gym.jpg",
      yOffsetPicture: 20, // in [percent]
      objective:      data.objective || null,

      goalDeletionRequest: 0, // Must be 0, otherwise Cloud function might get triggered

      // challengeId:  65634534534543,
      // ^ Not required for isTemplate
      // ^ Id of the parent challenge or goal .. referring to the template from the sidebar
      /*
      // isProjectCollection: false, // Not required for isTemplate
      tasks: data.isTemplate ? {} : {
        [task1Id]: empty_task(creatorUserId, { name: "Ziel 1", sortidx: 100, parent_id: lane1Id }, BACKEND),
        [task2Id]: empty_task(creatorUserId, { name: "Ziel 2", sortidx: 200, parent_id: lane1Id }, BACKEND),
        [task3Id]: empty_task(creatorUserId, { name: "Ziel 3", sortidx: 300, parent_id: lane1Id }, BACKEND),
      },
      cachedHighscore: data.isTemplate ? {} : {
        [creatorUserId]: { score: 0 }
      },
      */
      /* {
        // image: null,
        // x: 200,
        // y: 100,
        // width: 300,
        // height: 166,
        // name: "goal1img",
        // draggable: true,
        // scaleX: 1,
        // scaleY: 1
      }, */
      // commitments: {},
      // NEU 12.12.2018
      /*
      lanes: data.isTemplate ? {} : {
        [lane1Id]: empty_lane( "Lane 1", creatorUserId, BACKEND ),
        [lane2Id]: empty_lane( "Lane 2", creatorUserId, BACKEND )
      } */
    };
  },

  fields: [
    {
      model: 'name',
      label: 'Name of goal',
      type: 'input',
      inputType: 'text',
      readonly: false,
      disabled: false,
      validate_bolt_type: 'String'
    },
    {
      model: 'objective',
      label: 'This is the goal objective',
      type: 'input',
      inputType: 'text',
      readonly: false,
      disabled: false,
      validate_bolt_type: 'String'
    },
    {
      model: 'description',
      label: 'This is the goal description',
      type: 'textarea',
      inputType: 'text',
      readonly: false,
      disabled: false,
      validate_bolt_type: 'String'
    },
    {
      model: 'rules',
      label: 'These are the goal rules', // Move to challenge?
      type: 'textArea',
      inputType: 'text',
      readonly: false,
      disabled: false,
      validate_bolt_type: 'String'
    },
    {
      model: 'deleted',
      label: 'Soft delete',
      type: 'checkbox',
      default: false,
      validate_bolt_type: 'Boolean'
    },
    {
      model: 'visibility',
      label: 'Visibility',
      type: 'select',
      values: ['public', 'private'],
      validate_bolt_type: 'String'
    },
    {
      model: 'isTeamgoal',
      label: 'Is teamlane',
      type: 'checkbox',
      default: false,
      validate_bolt_type: 'Boolean'
    },
    {
      model: 'picture',
      label: 'picture',
      type: 'image',
      validate_bolt_type: 'String'
    },
    { model: 'members' }, /* validate_bolt_type: 'GoalMember[]' */
    { model: 'deadlineList', validate_bolt_type: 'GoalDeadline[]' },
    { model: 'cachedHighscore', validate_bolt_type: 'Object[]' }, // TODO
    { model: 'createdBy', validate_bolt_type: 'UserID' },
    { model: 'createdAt', validate_bolt_type: 'ServerTimestamp' },
    { model: 'challengeId', validate_bolt_type: 'String | Number' },
    { model: 'yOffsetPicture', validate_bolt_type: 'Number' },
    // ---
    { model: 'goalDeletionRequest', validate_bolt_type: 'ServerTimestamp' },
  ]
};
